module.exports = __webpack_public_path__ + "static/media/sandia_big.879c431c.png";